import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import type { ITemplateFormState, IShareableBusiness } from '@/@types/messageTemplates';
import type { Id } from '../../../convex/_generated/dataModel';

interface ITemplateSharingSectionProps {
  formState: ITemplateFormState;
  setFormState: React.Dispatch<React.SetStateAction<ITemplateFormState>>;
  businessId: Id<'businesses'>;
  userBusinesses: IShareableBusiness[];
}

export function TemplateSharingSection({
  formState,
  setFormState,
  businessId,
  userBusinesses,
}: ITemplateSharingSectionProps) {
  const handleBusinessToggle = (targetBusinessId: Id<'businesses'>, checked: boolean) => {
    setFormState(prev => ({
      ...prev,
      sharedWithBusinessIds: checked
        ? [...prev.sharedWithBusinessIds, targetBusinessId]
        : prev.sharedWithBusinessIds.filter(id => id !== targetBusinessId),
    }));
  };

  return (
    <div className="space-y-3 pt-2 border-t border-border">
      <div className="flex items-center gap-3">
        <Checkbox
          id="shareable"
          checked={formState.isShareable}
          onCheckedChange={checked =>
            setFormState(prev => ({
              ...prev,
              isShareable: !!checked,
              sharedWithBusinessIds: checked ? prev.sharedWithBusinessIds : [],
            }))
          }
        />
        <Label htmlFor="shareable" className="cursor-pointer">
          Shareable template
        </Label>
      </div>

      {formState.isShareable && userBusinesses.length > 0 && (
        <div className="pl-6 space-y-2">
          <Label className="text-sm text-muted-foreground">Share with businesses</Label>
          <div className="flex flex-wrap gap-3">
            {userBusinesses
              .filter(b => b._id !== businessId)
              .map(business => (
                <label key={business._id} className="flex items-center gap-2 cursor-pointer">
                  <Checkbox
                    checked={formState.sharedWithBusinessIds.includes(business._id)}
                    onCheckedChange={checked => handleBusinessToggle(business._id, !!checked)}
                  />
                  <span className="text-sm">{business.name}</span>
                </label>
              ))}
          </div>
        </div>
      )}
    </div>
  );
}
